import React, { Fragment, ReactNode } from 'react'

import { Listbox, Transition } from '@headlessui/react'
import { twMerge } from 'tailwind-merge'

export interface IOptions {
  children?: ReactNode
  className?: string
  showAbove?: boolean
}

const Options: React.FC<IOptions> = ({
  children,
  className,
  showAbove = undefined,
}) => {
  return (
    <div className="relative">
      <Transition
        as={Fragment}
        leave="transition ease-in duration-100"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
        // @ts-ignore
        className={
          showAbove ? 'bottom-full' : showAbove !== undefined ? 'top-full' : ''
        }
      >
        <Listbox.Options
          className={twMerge(
            'absolute z-50 max-h-60 w-full overflow-auto rounded-md bg-white dark:bg-primary-800 text-base shadow-lg border border-primary-300 dark:border-primary-700 focus:outline-none sm:text-sm',
            className ?? '',
          )}
        >
          {children}
        </Listbox.Options>
      </Transition>
    </div>
  )
}

export default Options
